import { createGeoTagsManager } from '../../utils/createGeoTagsManager';
import { IJsonQueryHouse } from '../../../../api-models/common/json_query';

export const geoHouseTagsManager = createGeoTagsManager<IJsonQueryHouse>({
  jsonQueryKey: 'house',
  labelGetter: ({ geoTags, geoValue }) => geoTags.houses[geoValue.id] || 'Неизвестный адрес',
  id: 'geoHouse',
});
